module.exports = __webpack_public_path__ + "img/right-arrow-selected.5d310837.svg";